import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import NewHome from "./pages/NewHome";
import Jupyter from "./pages/Jupyter";
import Data from "./pages/Data";
import NavBar from "./containers/NavBar.jsx";
import { Helmet } from "react-helmet";
import RedirectPageToLogin from "./pages/RedirectPageToLogin.jsx";
import LoadingPage from "./pages/LoadingPage";

function App() {
  return (
    <div>
      <Helmet>
        <title>310 panel</title>
      </Helmet>
      <div className="w-full">
        <NavBar />
        <Routes>
          <Route path="/" element={<NewHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signout" element={<RedirectPageToLogin />} />
          <Route path="/home/cluster" element={<Jupyter />} />
          <Route path="/home/data" element={<Data />} />
          <Route path="*" element={<LoadingPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
